import {
    ITEM,
    ITEM_SUCCESS,
    ITEM_ERROR,
    ADD_ITEM,
    ADD_ITEM_SUCCESS,
    ADD_ITEM_ERROR,
    UPDATE_ITEM,
    UPDATE_ITEM_SUCCESS,
    UPDATE_ITEM_ERROR,
    DELETE_ITEM,
    DELETE_ITEM_SUCCESS,
    DELETE_ITEM_ERROR,
    ITEMICON,
    ITEMICON_ERROR,
    ITEMICON_SUCCESS,
    ITEM_DATE,
    ITEM_DATE_ERROR,
    ITEM_DATE_SUCCESS
} from "../constants/itemConstant";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    itemsFiltered:[],
    loadingTitle: '',
    loadingMessage: ''
};

function itemReducer(state = initialState, action) {
    switch (action.type) {
        case ITEM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEMS ARE BEING LOADED',
                'type': action.type
            });
        case ITEM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case ITEM_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'itemData': action.data
            });
        case ITEM_DATE:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEMS ARE BEING LOADED',
                'type': action.type
            });
        case ITEM_DATE_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case ITEM_DATE_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'itemsFiltered': action.data
            });
        case ADD_ITEM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEM IS BEING SAVED',
                'type': action.type
            });
        case ADD_ITEM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case ADD_ITEM_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'itemData': [...state.itemData, action.data]
            });
        case UPDATE_ITEM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEM IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_ITEM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case UPDATE_ITEM_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'itemData': state.itemData? state.itemData.map(
                    i => ( i._id === action.data._id ) ? action.data : i
                ) : [...action.data]
            });
        case DELETE_ITEM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEM IS BEING DELETED',
                'type': action.type
            });
        case DELETE_ITEM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case DELETE_ITEM_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'itemData': state.itemData.filter(item => item._id !== action.data)

            });
        case ITEMICON:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': ''
            });
        case ITEMICON_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': action

            });
        case ITEMICON_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'itemsIconsData': action.data


            });
        default:
            return state;
    }
}

export default itemReducer;

